import React from 'react';
import LikedPosts from '../components/LikedPosts';

const LikedPostsPage = () => {
    return <LikedPosts />;
};

export default LikedPostsPage;